import NosOutils from './Outils-formation.js'

export default function content_evenement() {
    const ContentEvenement =
        <>
            <div className='contentContainer contentEvenement'>
                <div className='titreProjet'>
                    <h5 style={{ fontWeight: 'bold', marginBottom: '20px' }}>Des événements sur mesure en fonction de vos objectifs</h5>
                </div>
                <div>
                    <div className='mandat'>
                        <p className="vertical-timeline-element-subtitle">Grâce à notre expertise créative de 30 ans en événementiel, nous concevons et orchestrons, des expériences uniques qui subliment vos moments corporatifs.</p>
                    </div>
                </div>
                <div>
                    <div className='imageOfproject'>
                        <div className='iframeWrapper'>
                            <div style={{ padding: "56.25% 0 0 0", position: "relative" }}><iframe src="https://player.vimeo.com/video/1053883313?h=63fee69b47&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} title="BIXI_INTRO_v2_1920x1080_20mbps"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
                        </div>
                    </div>
                    <div className='outil-2'>
                        <div className='solution-body-event'>
                            <NosOutils />
                        </div>
                    </div>
                </div>
            </div>
        </>

    return ContentEvenement;
}